// extracted by mini-css-extract-plugin
export default {"playerDiv":"ViewVideo_playerDiv__ZY9sO"};